module.exports = __webpack_public_path__ + "aa67a1efee60f4797cbdaeaaf160b877.jpg";


//////////////////
// WEBPACK FOOTER
// ./public/content/assets/banner_press_still.jpg
// module id = 635
// module chunks = 0